import React, { useEffect } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { useRecoilState } from 'recoil';
import IconButton from '@material-ui/core/IconButton';
import CancelIcon from '@material-ui/icons/Cancel';
import { makeStyles } from '@material-ui/core/styles';

import { reminderTabListState, reminderTabIndexState, IReminder } from '../store/ReminderStore';
import ContentsWrapper from '../../../Public/Wrapper/ContentsWrapper';
import Header from '../../../Public/Header/Header';
import ReminderList from "./List";
import ReminderDetail from "./Detail";
const useStyles = makeStyles(() => ({
  margin: {
    margin: "0 0 0 10px",
  },
}));

const Reminder = () => {

  const [tabListItem, setTabListItem] = useRecoilState(reminderTabListState);
  const [tabIndex, setTabIndex] = useRecoilState(reminderTabIndexState);

  const muiClasses = useStyles();

  //init Tab list when init
  useEffect(() => {
    setTabListItem([]);
    setTabIndex(0);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {

    if (tabListItem.length < tabIndex - 1) {

      setTabIndex(0);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabListItem, tabIndex]);

  const addTab = (item: IReminder) => {

    const thisIndex = tabListItem.findIndex((i: IReminder) => {
      if (i.ReminderTypeId === item.ReminderTypeId)
        return true;

      return false;
    });

    //if (searchTab.length == 0) {
    if (thisIndex < 0) {
      setTabListItem([...tabListItem, item]);
    }
    else {

      setTabIndex(thisIndex + 2);
    }
  };

  const removeTab = (removeItem: IReminder) => {

    const filtered = tabListItem.filter((i: IReminder) => {
      return i.ReminderTypeId !== removeItem.ReminderTypeId;
    });

    setTabListItem(filtered);
  };

  return (
    <ContentsWrapper header={<Header title="Reminder" />}>
      <div className="row no-gutters">
        <div className="col-md-12  mt-3">
          <div className="tab-content" id="myTabContent">
            <Tabs forceRenderTabPanel selectedIndex={tabIndex} onSelect={index => setTabIndex(index)}>
              <TabList>
                <Tab height="38" >Reminder</Tab>
                <Tab height="38" >Add </Tab>
                {
                  tabListItem?.map((item) =>
                    <Tab key={item.ReminderId} height="38">
                      {item.AssetPlate}-{item.ReminderTypeName}
                      <IconButton aria-label="delete" className={muiClasses.margin} size="small" onClick={() => removeTab(item)}>
                        <CancelIcon fontSize="inherit" />
                      </IconButton>
                    </Tab>
                  )
                }
              </TabList>
              <TabPanel>
                <ReminderList addTab={addTab} />
              </TabPanel>
              <TabPanel>
                <ReminderDetail reminderRow={undefined} />
              </TabPanel>
              {
                tabListItem?.map((item: IReminder) => (
                  <TabPanel key={item.ReminderTypeId} headers={item.Name}>
                    <ReminderDetail
                      reminderRow={item}
                    />
                  </TabPanel>
                ))
              }
            </Tabs>
          </div>
        </div>
      </div>
    </ContentsWrapper>
  );
};

export default Reminder;